import React, { useEffect } from "react";
import "./modak.css";
import useIsNarrow from "./useIsNarrow";

/**
 * CRA's css-loader tries to resolve `url("/public-asset.jpg")` inside .css
 * files as a webpack module and fails to build — public-folder images have
 * to be referenced as plain strings (JSX `src`, or an inline style, both
 * left untouched by webpack) instead. This wrapper owns the one background
 * swap every Modak screen needs, applied to `body` itself (matching the old
 * PHP app's `<body class="back-bg2">`) rather than a per-page div — repeat/
 * size/position/attachment live in index.css's `body` rule since those are
 * plain keywords, not `url()` paths, so only the image URL needs to be set
 * here in JS.
 */
export default function ModakBackdrop({ children, center, fullHeight }) {
  const narrow = useIsNarrow();
  const bg = narrow ? "/modak-assets/background_mob.jpg" : "/modak-assets/background-desk.jpg";

  useEffect(() => {
    document.body.style.backgroundImage = `url("${bg}")`;
  }, [bg]);

  return (
    <div
      className={`modak-page${center ? " modak-page--center" : ""}${
        fullHeight ? " modak-page--full-height" : ""
      }`}
    >
      {children}
    </div>
  );
}
